export const groceryStores = {
  type: "FeatureCollection",
  name: "Grocery_Store_Locations",
  crs: {
    type: "name",
    properties: {
      name: "urn:ogc:def:crs:OGC:1.3:CRS84",
    },
  },
  features: [
    {
      type: "Feature",
      properties: {
        STORENAME: "Target ",
        ADDRESS: "7828 GEORGIA AVENUE NW",
        ZIPCODE: 20012,
        PHONE: 2028923822,
        WARD: "Ward 4",
        SSL: "2960    0017",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_1",
        XCOORD: 397662.57,
        YCOORD: 146280.07,
        MAR_ID: 300512,
        GLOBALID: "{CE302122-4E8D-4DC7-845B-06563B993F66}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 641,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02698057901294, 38.984455298886594],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "International Progresso Market",
        ADDRESS: "7719 GEORGIA AVENUE NW",
        ZIPCODE: 20012,
        PHONE: 2025455015,
        WARD: "Ward 4",
        SSL: "2961    0810",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_2",
        XCOORD: 397741.8,
        YCOORD: 146169.97,
        MAR_ID: 285417,
        GLOBALID: "{2C18863D-40DE-4F66-AA59-46F1C65D67F2}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 642,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02606575460848, 38.98346370182271],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Jocelyn’s Market ",
        ADDRESS: "6404 GEORGIA AVENUE NW",
        ZIPCODE: 20012,
        PHONE: 2027227574,
        WARD: "Ward 4",
        SSL: "2945    0839",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_3",
        XCOORD: 397591.16,
        YCOORD: 144428,
        MAR_ID: 285334,
        GLOBALID: "{A0B448C3-B3FB-49FE-B8BF-1FEBA3CEA642}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 643,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02779827340467, 38.96777123500419],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Magruder's",
        ADDRESS: "5626 CONNECTICUT AVENUE NW",
        ZIPCODE: 20015,
        PHONE: 2024644946,
        WARD: "Ward 3",
        SSL: "1860    0013",
        NOTES: " ",
        PRESENT90: "Yes",
        PRESENT95: "Yes",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_4",
        XCOORD: 393373.92,
        YCOORD: 144184.19,
        MAR_ID: 263860,
        GLOBALID: "{9ABE1C46-BB48-4110-B5BA-C6363CA3BD7A}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 644,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0764593007974, 38.96555324028618],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Safeway",
        ADDRESS: "5545 CONNECTICUT AVENUE NW",
        ZIPCODE: 20015,
        PHONE: 2022446097,
        WARD: "Ward 3",
        SSL: "1867    0092",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "Yes",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_5",
        XCOORD: 393508.13,
        YCOORD: 144078.34,
        MAR_ID: 263999,
        GLOBALID: "{902F540E-FE16-43A5-8010-CD84E94B28B7}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 645,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0749096653148, 38.96460071978338],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Walmart Supercenter",
        ADDRESS: "5929 GEORGIA AVENUE NW",
        ZIPCODE: 20011,
        PHONE: 2027193770,
        WARD: "Ward 4",
        SSL: "2986    0039",
        NOTES: "Georgia Ave",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_6",
        XCOORD: 397635.44,
        YCOORD: 143796.02,
        MAR_ID: 254296,
        GLOBALID: "{A40991EF-B8F3-44B5-AE35-48BD1C814681}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 646,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0272851396928, 38.962078321939],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Walmart Supercenter",
        ADDRESS: "310 RIGGS ROAD NE",
        ZIPCODE: 20011,
        PHONE: 2027564418,
        WARD: "Ward 4",
        SSL: "3748    0052",
        NOTES: "Riggs Road",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_7",
        XCOORD: 399814.33,
        YCOORD: 143340.35,
        MAR_ID: 311574,
        GLOBALID: "{4BA6EDB6-4A42-4EBE-B792-63208B1427FE}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 647,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0021444681289, 38.957976693092185],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Tropimart International Foods",
        ADDRESS: "607 KENNEDY STREET NW",
        ZIPCODE: 20011,
        PHONE: 2026272752,
        WARD: "Ward 4",
        SSL: "3207    0089",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "No",
        PRESENT16: "No",
        PRESENT17: "No",
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "No",
        PRESENT24: "No",
        GIS_ID: "GroceryStorePt_8",
        XCOORD: 398152.47,
        YCOORD: 143188.21,
        MAR_ID: 246733,
        GLOBALID: "{4FC86176-5DF9-44E1-B2C2-AFEA77046638}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 648,
        PRESENT25: "No",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0213178876896, 38.95660425176424],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Rodman’s ",
        ADDRESS: "5100 WISCONSIN AVENUE NW",
        ZIPCODE: 20016,
        PHONE: 2023633466,
        WARD: "Ward 3",
        SSL: "1656    0009",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_9",
        XCOORD: 392731.53,
        YCOORD: 143157.89,
        MAR_ID: 265883,
        GLOBALID: "{572E410A-B3F5-4080-AD0F-CAE80BCBB60A}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 649,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.08386082768217, 38.95630298829646],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Avenue Supermarket",
        ADDRESS: "5010 1ST STREET NW",
        ZIPCODE: 20011,
        PHONE: 2027261330,
        WARD: "Ward 4",
        SSL: "3403    0806",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_10",
        XCOORD: 398925.97,
        YCOORD: 142605.69,
        MAR_ID: 243587,
        GLOBALID: "{676068FB-DF0B-4A78-896F-774E4BFD51D0}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 650,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.01239283490291, 38.951358041575816],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Whole Foods Market",
        ADDRESS: "4530 40TH STREET NW",
        ZIPCODE: 20016,
        PHONE: 2022375800,
        WARD: "Ward 3",
        SSL: "1770    0804",
        NOTES: "Tenleytown location",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_11",
        XCOORD: 393133.54,
        YCOORD: 142358.92,
        MAR_ID: 265175,
        GLOBALID: "{341736A6-6C41-4077-A93A-673C56BC463F}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 651,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.07921470836419, 38.949108887229876],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Target ",
        ADDRESS: "4500 WISCONSIN AVENUE NW",
        ZIPCODE: 20016,
        PHONE: 2022925573,
        WARD: "Ward 3",
        SSL: "1730    0015",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_12",
        XCOORD: 393017.52,
        YCOORD: 142295.49,
        MAR_ID: 264422,
        GLOBALID: "{13461840-7DAB-4095-842E-E0BE058C384E}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 652,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.08055249629905, 38.94853657775952],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Wagshal’s Market ",
        ADDRESS: "4845 MASSACHUSETTS AVENUE NW",
        ZIPCODE: 20016,
        PHONE: 2023630777,
        WARD: "Ward 3",
        SSL: "1499    0001",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "No",
        PRESENT16: "No",
        PRESENT17: "No",
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_13",
        XCOORD: 391699.01,
        YCOORD: 141984.27,
        MAR_ID: 284992,
        GLOBALID: "{83901818-3431-43A2-9828-2782605BDA76}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 653,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0957591117584, 38.9457215516],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Giant",
        ADDRESS: "4303 CONNECTICUT AVENUE NW",
        ZIPCODE: 20008,
        PHONE: 2023648250,
        WARD: "Ward 3",
        SSL: "2049    0805",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "Yes",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_14",
        XCOORD: 394523.79,
        YCOORD: 141846.96,
        MAR_ID: 301784,
        GLOBALID: "{A5398418-0FF0-4A39-80C8-117C98ABB687}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 654,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.06317251045735, 38.944506775935366],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Yes! Organic",
        ADDRESS: "4100 GEORGIA AVENUE NW",
        ZIPCODE: 20011,
        PHONE: 2022915790,
        WARD: "Ward 4",
        SSL: "2910    0810",
        NOTES: "Petworth",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_15",
        XCOORD: 397786.99,
        YCOORD: 141460.14,
        MAR_ID: 300492,
        GLOBALID: "{67020644-0363-4EEF-BB0C-2F5EC3D7B9B5}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 655,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0255289707541, 38.94103647207616],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Morazan Grocery Store",
        ADDRESS: "3928 14TH STREET NW",
        ZIPCODE: 20011,
        PHONE: 2027237480,
        WARD: "Ward 4",
        SSL: "2693    0044",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_70",
        XCOORD: 397136.32,
        YCOORD: 141283.89,
        MAR_ID: 259021,
        GLOBALID: "{66C9FCED-A01E-41CD-B0E2-8C2FEE4DC7D3}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 656,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.03303361445171, 38.93944688026953],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Yes! Organic",
        ADDRESS: "3809 12TH STREET NE",
        ZIPCODE: 20017,
        PHONE: 2028327715,
        WARD: "Ward 5",
        SSL: "3925    0085",
        NOTES: "Brookland",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_17",
        XCOORD: 400832.73,
        YCOORD: 140992.28,
        MAR_ID: 30397,
        GLOBALID: "{9393FE43-2ED5-4EDF-9759-3292D6A94B37}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 657,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.99039744206605, 38.93682424490822],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Target ",
        ADDRESS: "3505 CONNECTICUT AVENUE NW",
        ZIPCODE: 20008,
        PHONE: 2028923794,
        WARD: "Ward 3",
        SSL: "2222    0015",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_18",
        XCOORD: 394970.18,
        YCOORD: 140886.73,
        MAR_ID: 301779,
        GLOBALID: "{4BB2D833-8123-4785-8757-A7A7AE7727B6}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 658,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0580161995249, 38.935859413660296],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Streets Market",
        ADDRESS: "3427 CONNECTICUT AVENUE NW ",
        ZIPCODE: 20008,
        PHONE: 2022449114,
        WARD: "Ward 3",
        SSL: "2219    0809",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_19",
        XCOORD: 394981.35,
        YCOORD: 140818.27,
        MAR_ID: 219257,
        GLOBALID: "{0BE52838-6678-4767-B12D-4DCD6CC38AF2}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 659,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.05788686412507, 38.93524276936389],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Yes! Organic",
        ADDRESS: "3425 CONNECTICUT AVENUE NW",
        ZIPCODE: 20008,
        PHONE: 2023631559,
        WARD: "Ward 3",
        SSL: "2219    0005",
        NOTES: "Cleveland Park",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_20",
        XCOORD: 394989.7,
        YCOORD: 140809.79,
        MAR_ID: 219254,
        GLOBALID: "{99B96733-94BC-4168-996F-E13F7739FDD0}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 660,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0577904942142, 38.93516642663929],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Giant",
        ADDRESS: "3336 WISCONSIN AVENUE NW",
        ZIPCODE: 20016,
        PHONE: 2022445922,
        WARD: "Ward 3",
        SSL: "1920    0844",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "Yes",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_71",
        XCOORD: 393671.02,
        YCOORD: 140720.27,
        MAR_ID: 223125,
        GLOBALID: "{88889CB0-2908-48D6-89DC-9F2EA4E383E3}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 661,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.07299916212476, 38.9343514937201],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Panam Grocery",
        ADDRESS: "3552 14TH STREET NW",
        ZIPCODE: 20010,
        PHONE: 2025450290,
        WARD: "Ward 1",
        SSL: "2688    0054",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_21",
        XCOORD: 397131.92,
        YCOORD: 140889.71,
        MAR_ID: 243394,
        GLOBALID: "{10A82BC1-1BFD-4D64-97FE-DD857E19B37B}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 662,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.033083504474, 38.93589900198148],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Giant",
        ADDRESS: "1345 PARK ROAD NW",
        ZIPCODE: 20010,
        PHONE: 2027771077,
        WARD: "Ward 1",
        SSL: "2837    0079",
        NOTES: "Tivoli Square",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_23",
        XCOORD: 397232.21,
        YCOORD: 140326.39,
        MAR_ID: 297595,
        GLOBALID: "{8A0BF12C-0187-411D-AF20-D20BCF51034F}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 663,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0319236902472, 38.93082173909141],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "El Progreso Market",
        ADDRESS: "3158 MOUNT PLEASANT STREET NW",
        ZIPCODE: 20010,
        PHONE: 2024621151,
        WARD: "Ward 1",
        SSL: "2596    1055",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_24",
        XCOORD: 396681.69,
        YCOORD: 140258.18,
        MAR_ID: 236467,
        GLOBALID: "{7B9E3417-64EB-4153-A7C8-C5D5312ACC23}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 664,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.03827261674165, 38.93020537550059],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Good Food Markets",
        ADDRESS: "2006 RHODE ISLAND AVENUE NE",
        ZIPCODE: 20018,
        PHONE: 2022488494,
        WARD: "Ward 5",
        SSL: "4219    0030",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "No",
        PRESENT23: "No",
        PRESENT24: "No",
        GIS_ID: "GroceryStorePt_25",
        XCOORD: 402183.58,
        YCOORD: 140174.04,
        MAR_ID: 53027,
        GLOBALID: "{EE5A54C1-FCF9-4438-AD63-D0068084835E}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 665,
        PRESENT25: "No",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97481915156219, 38.92945097121794],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Target",
        ADDRESS: "3100 14TH STREET NW",
        ZIPCODE: 20010,
        PHONE: 2027773773,
        WARD: "Ward 1",
        SSL: "2674    0721",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_26",
        XCOORD: 397140.04,
        YCOORD: 140158.41,
        MAR_ID: 306304,
        GLOBALID: "{E4D349AB-9F8A-4A4F-AE42-9E15C64AE5A9}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 666,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.03298601467985, 38.92930822797337],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Safeway",
        ADDRESS: "1747 COLUMBIA ROAD NW",
        ZIPCODE: 20009,
        PHONE: 2026670774,
        WARD: "Ward 1",
        SSL: "2580    0512",
        NOTES: " ",
        PRESENT90: "Yes",
        PRESENT95: "Yes",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_27",
        XCOORD: 396445.44,
        YCOORD: 139593.32,
        MAR_ID: 284083,
        GLOBALID: "{7C1459D3-4205-465C-8589-CDC4A462B587}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 667,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.04099386279987, 38.92421518348707],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Save-A-Lot",
        ADDRESS: "514 RHODE ISLAND AVENUE NE",
        ZIPCODE: 20002,
        PHONE: 2026363780,
        WARD: "Ward 5",
        SSL: "3629    0007",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "No",
        PRESENT23: "No",
        PRESENT24: "No",
        GIS_ID: "GroceryStorePt_72",
        XCOORD: 400008.27,
        YCOORD: 139329.72,
        MAR_ID: 288529,
        GLOBALID: "{09F34878-24DD-4586-B191-15D479E733DF}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 668,
        PRESENT25: "No",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.99990690595715, 38.9218477803563],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Yes! Organic",
        ADDRESS: "1825 COLUMBIA ROAD NW",
        ZIPCODE: 20009,
        PHONE: 2024625150,
        WARD: "Ward 1",
        SSL: "2549    0636",
        NOTES: "Adams Morgan",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_29",
        XCOORD: 396209.7,
        YCOORD: 139325.82,
        MAR_ID: 295011,
        GLOBALID: "{E4E3D6C8-C808-483E-B1FD-7C24CD0DF1F8}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 669,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.04371096490623, 38.92180447221158],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Whole Foods Market",
        ADDRESS: "2323 WISCONSIN AVENUE NW",
        ZIPCODE: 20007,
        PHONE: 2023335393,
        WARD: "Ward 3",
        SSL: "1299    1028",
        NOTES: "Georgetown",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_30",
        XCOORD: 393789.84,
        YCOORD: 139230.75,
        MAR_ID: 284358,
        GLOBALID: "{7F249106-38C6-4211-9E2D-DE35D95AB1ED}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 670,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0716152331314, 38.92093428097333],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Costco Wholesale",
        ADDRESS: "2441 MARKET STREET NE",
        ZIPCODE: 20018,
        PHONE: 2022698540,
        WARD: "Ward 5",
        SSL: "4327    0004",
        NOTES: "Costco",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_31",
        XCOORD: 404259.71,
        YCOORD: 139220.21,
        MAR_ID: 309925,
        GLOBALID: "{582A1832-3715-4F9B-A072-024D908CED52}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 671,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.95088115617465, 38.92085095656862],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Streets Market",
        ADDRESS: "2400 14TH STREET NW",
        ZIPCODE: 20009,
        PHONE: 2022653300,
        WARD: "Ward 1",
        SSL: "2661    0864",
        NOTES: null,
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_32",
        XCOORD: 397217.8,
        YCOORD: 139209.69,
        MAR_ID: 234183,
        GLOBALID: "{F7E5C73D-8053-4889-8B2A-84BE61889AB6}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 672,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.03208536793328, 38.92076210575762],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Streets Market",
        ADDRESS: "1864 COLUMBIA ROAD NW",
        ZIPCODE: 20009,
        PHONE: 2027580658,
        WARD: "Ward 1",
        SSL: "2551    0063",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_33",
        XCOORD: 396224.29,
        YCOORD: 139209.43,
        MAR_ID: 235402,
        GLOBALID: "{A32952C5-FD79-4008-A590-64137F8F0F6C}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 673,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.04354207691901, 38.9207560561591],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Whole Foods Market",
        ADDRESS: "967 FLORIDA AVENUE NW",
        ZIPCODE: 20001,
        PHONE: 2025193400,
        WARD: "Ward 1",
        SSL: "2873    1102",
        NOTES: null,
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "No",
        PRESENT16: "No",
        PRESENT17: "No",
        PRESENT18: "No",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_79",
        XCOORD: 397861.5,
        YCOORD: 139107.39,
        MAR_ID: 319123,
        GLOBALID: "{7C0648AB-FB04-4997-85C8-EBAC703EA054}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 674,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02486798416666, 38.919757346222475],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Yes! Organic",
        ADDRESS: "2123 14TH STREET NW",
        ZIPCODE: 20009,
        PHONE: 2022326603,
        WARD: "Ward 1",
        SSL: "0235    0204",
        NOTES: "14th Street",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "No",
        PRESENT24: "No",
        GIS_ID: "GroceryStorePt_35",
        XCOORD: 397258.09,
        YCOORD: 138959.31,
        MAR_ID: 306454,
        GLOBALID: "{45FCE223-597A-4EE4-8E29-104D58F54BA1}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 675,
        PRESENT25: "No",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.03161975008753, 38.9185067273602],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Safeway",
        ADDRESS: "4865 MACARTHUR BOULEVARD NW",
        ZIPCODE: 20007,
        PHONE: 2023375649,
        WARD: "Ward 3",
        SSL: "1389    0025",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "Yes",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "No",
        PRESENT23: "No",
        PRESENT24: "No",
        GIS_ID: "GroceryStorePt_73",
        XCOORD: 391678.11,
        YCOORD: 138844.95,
        MAR_ID: 285004,
        GLOBALID: "{B781FF71-032E-4647-86D6-214D329796D9}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 676,
        PRESENT25: "No",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.09596212516878, 38.91744140841091],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Trader Joe's",
        ADDRESS: "2101 WISCONSIN AVENUE NW #A",
        ZIPCODE: 20007,
        PHONE: 2029448403,
        WARD: "Ward 3",
        SSL: "1299    0321",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_36",
        XCOORD: 394043.36,
        YCOORD: 138828.56,
        MAR_ID: 279531,
        GLOBALID: "{0A0E4B5E-71B9-4C2B-8AEC-B11810E99D37}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 677,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.06868826971424, 38.91731297728031],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Target ",
        ADDRESS: "1515 NEW YORK AVENUE NE",
        ZIPCODE: 20002,
        PHONE: 2029142396,
        WARD: "Ward 5",
        SSL: "4037    0011",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_37",
        XCOORD: 401560.12,
        YCOORD: 138710.47,
        MAR_ID: 311951,
        GLOBALID: "{0C4314DD-09D6-4C23-A6C1-598EB3475C4F}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 678,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.98201281403125, 38.91626798854294],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Safeway",
        ADDRESS: "1855 WISCONSIN AVENUE NW",
        ZIPCODE: 20007,
        PHONE: 2023333223,
        WARD: "Ward 2",
        SSL: "1299    1040",
        NOTES: " ",
        PRESENT90: "Yes",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_38",
        XCOORD: 394141.03,
        YCOORD: 138696.71,
        MAR_ID: 224665,
        GLOBALID: "{152A7BF1-F352-41DA-8C39-350BB15C9DA0}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 679,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.06756091263733, 38.91612588552244],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Trader Joe's",
        ADDRESS: "1914 14TH STREET NW",
        ZIPCODE: 20009,
        PHONE: 2029861591,
        WARD: "Ward 2",
        SSL: "0205    0847",
        NOTES: "14th Street NW",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_39",
        XCOORD: 397203.72,
        YCOORD: 138692.26,
        MAR_ID: 302384,
        GLOBALID: "{20462FC5-F80E-4B9E-8453-C77D29F6814A}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 680,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.03224561287334, 38.91610088111984],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Mom's Organic Market",
        ADDRESS: "1501 NEW YORK AVENUE NE",
        ZIPCODE: 20002,
        PHONE: 2027913826,
        WARD: "Ward 5",
        SSL: "4037    0821",
        NOTES: "Mom's",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_40",
        XCOORD: 401423.07,
        YCOORD: 138675.33,
        MAR_ID: 311943,
        GLOBALID: "{39DF581B-389F-4E1D-BDE3-AC542E23FAB1}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 681,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.98359318635836, 38.91595166823911],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Safeway",
        ADDRESS: "1701 CORCORAN STREET NW",
        ZIPCODE: 20009,
        PHONE: 2026676825,
        WARD: "Ward 2",
        SSL: "0155    0231",
        NOTES: " ",
        PRESENT90: "Yes",
        PRESENT95: "Yes",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_42",
        XCOORD: 396621.59,
        YCOORD: 138243.64,
        MAR_ID: 241699,
        GLOBALID: "{490DC6A4-034E-4AF9-ACD1-569A11F60998}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 682,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.03895582799449, 38.91205751595905],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Whole Foods Market",
        ADDRESS: "1440 P STREET NW ",
        ZIPCODE: 20005,
        PHONE: 2023324300,
        WARD: "Ward 2",
        SSL: "0210    0128",
        NOTES: "Logan Circle",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_74",
        XCOORD: 397088.79,
        YCOORD: 137959.45,
        MAR_ID: 279174,
        GLOBALID: "{E2BC2F94-FC35-429E-80F4-CCEFB72EB8A5}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 683,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.03356774007035, 38.909499107117675],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Metro Supermarket",
        ADDRESS: "2130 P STREET NW #5",
        ZIPCODE: 20037,
        PHONE: 2028333720,
        WARD: "Ward 2",
        SSL: "0068    0088",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_43",
        XCOORD: 395805.35,
        YCOORD: 137959.03,
        MAR_ID: 298500,
        GLOBALID: "{C99935D3-E9F5-4B87-B33E-567C27861A84}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 684,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0483654643336, 38.909490134936135],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Giant",
        ADDRESS: "1400 7TH STREET NW",
        ZIPCODE: 20001,
        PHONE: 2022380180,
        WARD: "Ward 2",
        SSL: "0398    0836",
        NOTES: "O Street Market",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_44",
        XCOORD: 398081.2,
        YCOORD: 137878.29,
        MAR_ID: 304153,
        GLOBALID: "{3B7BC6D4-B9C8-47C2-A6E3-3ABC4B866128}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 685,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02212530524505, 38.90877071707107],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Trader Joe's",
        ADDRESS: "350 FLORIDA AVENUE NE",
        ZIPCODE: 20002,
        PHONE: 2026081023,
        WARD: "Ward 5",
        SSL: "3587    0851",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "No",
        PRESENT16: "No",
        PRESENT17: "No",
        PRESENT18: "No",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_45",
        XCOORD: 399950.97,
        YCOORD: 137733.43,
        MAR_ID: 315607,
        GLOBALID: "{FA6F18F0-D92C-46A8-B126-8C41D9FDB874}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 686,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.00056757058083, 38.907467861810815],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Streets Market",
        ADDRESS: "1255 22ND STREET NW",
        ZIPCODE: 20037,
        PHONE: 2026520843,
        WARD: "Ward 2",
        SSL: "0070    0198",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_47",
        XCOORD: 395805.37,
        YCOORD: 137648.24,
        MAR_ID: 242473,
        GLOBALID: "{4A6B4F37-016E-45D8-9740-A4CAF5FEDFC1}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 687,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.04836333526443, 38.9066904312142],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Harris Teeter",
        ADDRESS: "1201 1ST STREET NE",
        ZIPCODE: 20002,
        PHONE: 2029861415,
        WARD: "Ward 6",
        SSL: "0711    0816",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_48",
        XCOORD: 399523.62,
        YCOORD: 137573.06,
        MAR_ID: 303728,
        GLOBALID: "{8CDC5267-E6E1-48AF-AFEA-78C495698D3E}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 688,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.00549454925675, 38.9060230649165],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Streets Market",
        ADDRESS: "51 M STREET NE ",
        ZIPCODE: 20002,
        PHONE: 2028981314,
        WARD: "Ward 6",
        SSL: "0673    0035",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_49",
        XCOORD: 399369.52,
        YCOORD: 137510.85,
        MAR_ID: 314143,
        GLOBALID: "{D3E48F1B-5213-4D23-9936-A3D4134F935E}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 689,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.00727113699227, 38.90546255831054],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Streets Market",
        ADDRESS: "1221 MASSACHUSSETTS AVENUE NW",
        ZIPCODE: 20005,
        PHONE: 2024147891,
        WARD: "Ward 2",
        SSL: "0282    0044",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_75",
        XCOORD: 397480.95,
        YCOORD: 137460.76,
        MAR_ID: 240918,
        GLOBALID: "{2F403E9E-AEA5-44A1-900D-95309EE11B4B}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 690,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02904442323587, 38.90500794562991],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Dean & DeLuca",
        ADDRESS: "3276 M STREET NW",
        ZIPCODE: 20007,
        PHONE: 2023422500,
        WARD: "Ward 2",
        SSL: "1186    0800",
        NOTES: "Georgetown",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "No",
        PRESENT23: "No",
        PRESENT24: "No",
        GIS_ID: "GroceryStorePt_50",
        XCOORD: 394349.18,
        YCOORD: 137435.69,
        MAR_ID: 273712,
        GLOBALID: "{82BF1711-E23B-4B68-B4DE-400EF03E897F}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 691,
        PRESENT25: "No",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.06515039926714, 38.90476755049142],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Trader Joe's",
        ADDRESS: "1101 25TH STREET NW",
        ZIPCODE: 20037,
        PHONE: 2022961921,
        WARD: "Ward 2",
        SSL: "0025    0022",
        NOTES: "West End",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_51",
        XCOORD: 395401.79,
        YCOORD: 137371.89,
        MAR_ID: 303613,
        GLOBALID: "{5D7EA9EE-610E-4F06-B17D-C8BA29421FAA}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 692,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.05301445799768, 38.90419895489277],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Aldi",
        ADDRESS: "901 17TH STREET NE",
        ZIPCODE: 20002,
        PHONE: 8559552534,
        WARD: "Ward 5",
        SSL: "4488    0040",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_76",
        XCOORD: 401905.76,
        YCOORD: 137078.87,
        MAR_ID: 308898,
        GLOBALID: "{D1A3CEBE-A387-4471-BCA7-AA47D3011EC6}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 693,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97803182686684, 38.901569290610766],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Whole Foods Market",
        ADDRESS: "2201 I STREET NW",
        ZIPCODE: 20037,
        PHONE: 2022961660,
        WARD: "Ward 2",
        SSL: "0054    7011",
        NOTES: "Foggy Bottom",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_53",
        XCOORD: 395743.74,
        YCOORD: 137007.55,
        MAR_ID: 310098,
        GLOBALID: "{B259B91E-D7EE-4FBD-82DB-715522CD5542}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 694,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.04906991376862, 38.90091857333819],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Safeway",
        ADDRESS: "1601 MARYLAND AVENUE NE",
        ZIPCODE: 20002,
        PHONE: 2023986903,
        WARD: "Ward 5",
        SSL: "4493    0001",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_54",
        XCOORD: 401754.81,
        YCOORD: 136968.47,
        MAR_ID: 297814,
        GLOBALID: "{494D49F3-9C9B-470E-B1F8-9C98DF9A7C02}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 695,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.9797723166244, 38.90057508208878],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Giant",
        ADDRESS: "300 H STREET NE",
        ZIPCODE: 20002,
        PHONE: 2025485100,
        WARD: "Ward 6",
        SSL: "0776    0054",
        NOTES: "H Street NE",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_55",
        XCOORD: 399857.33,
        YCOORD: 136953.04,
        MAR_ID: 308511,
        GLOBALID: "{0AC05C96-D2DA-4FA4-AD8E-B71D2BA7A9D6}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 696,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.00164702126361, 38.900437822269424],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Walmart Supercenter",
        ADDRESS: "99 H STREET NW",
        ZIPCODE: 20001,
        PHONE: 2027192110,
        WARD: "Ward 6",
        SSL: "0623    0836",
        NOTES: "H Street",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "No",
        PRESENT24: "No",
        GIS_ID: "GroceryStorePt_56",
        XCOORD: 398960.4,
        YCOORD: 136949.39,
        MAR_ID: 310062,
        GLOBALID: "{64362A25-E4DC-498A-99E0-AFD5F5458CD1}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 697,
        PRESENT25: "No",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.01198706322641, 38.90040433820317],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Whole Foods Market",
        ADDRESS: "600 H STREET NE",
        ZIPCODE: 20002,
        PHONE: 2024697410,
        WARD: "Ward 6",
        SSL: "0858    0866",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "No",
        PRESENT16: "No",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_57",
        XCOORD: 400160.9,
        YCOORD: 136949.34,
        MAR_ID: 311750,
        GLOBALID: "{0E5F6476-B227-4331-93A1-82D61AEB140B}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 698,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.99814738644127, 38.90040448832145],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Market at Columbia Plaza",
        ADDRESS: "516 23RD STREET NW",
        ZIPCODE: 20037,
        PHONE: 2022233517,
        WARD: "Ward 2",
        SSL: "0033    0087",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_58",
        XCOORD: 395563.58,
        YCOORD: 136520.96,
        MAR_ID: 298798,
        GLOBALID: "{39BDDDB8-33B0-4171-B79A-27CD150E7C2F}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 699,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.05114371697833, 38.8965343041196],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Trader Joe's",
        ADDRESS: "750 PENNSYLVANIA AVENUE SE",
        ZIPCODE: 20003,
        PHONE: 2026980190,
        WARD: "Ward 6",
        SSL: "0901    0804",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "No",
        PRESENT16: "No",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_59",
        XCOORD: 400388.38,
        YCOORD: 135210.64,
        MAR_ID: 313096,
        GLOBALID: "{7C2588A4-1864-491B-A41D-9B024BFF2FB1}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 700,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.9955259196549, 38.88474156067008],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Safeway",
        ADDRESS: "415 14TH STREET SE",
        ZIPCODE: 20003,
        PHONE: 2025474333,
        WARD: "Ward 6",
        SSL: "1042    0829",
        NOTES: " ",
        PRESENT90: "Yes",
        PRESENT95: "Yes",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_60",
        XCOORD: 401167.04,
        YCOORD: 135078.34,
        MAR_ID: 26239,
        GLOBALID: "{359C10E9-C72A-4432-B4FB-D7E3E217154C}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 701,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.9865515080303, 38.88354906285547],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Yes! Organic",
        ADDRESS: "410 8TH STREET SE",
        ZIPCODE: 20003,
        PHONE: 2025469850,
        WARD: "Ward 6",
        SSL: "0925    0026",
        NOTES: "Capitol Hill",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_61",
        XCOORD: 400463.21,
        YCOORD: 135060.64,
        MAR_ID: 300093,
        GLOBALID: "{33159ACB-655C-4DFD-8C0C-E1AE15930E24}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 702,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.99466355031821, 38.88339026661765],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Whole Foods Market",
        ADDRESS: "101 H STREET SE",
        ZIPCODE: 20003,
        PHONE: 2024697280,
        WARD: "Ward 8",
        SSL: "0737    0827",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_62",
        XCOORD: 399591.26,
        YCOORD: 134715.97,
        MAR_ID: 315544,
        GLOBALID: "{4F07489C-1004-4754-94C9-F628F12AAAC7}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 703,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.00471301493637, 38.88028537177096],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Harris Teeter",
        ADDRESS: "1350 POTOMAC AVENUE SE",
        ZIPCODE: 20003,
        PHONE: 2025431040,
        WARD: "Ward 6",
        SSL: "1045    0138",
        NOTES: "Jenkins Row",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "No",
        PRESENT23: "No",
        PRESENT24: "No",
        GIS_ID: "GroceryStorePt_63",
        XCOORD: 401160.72,
        YCOORD: 134707.64,
        MAR_ID: 303730,
        GLOBALID: "{496859BA-CC24-41CA-8667-F6B0E8C7A3CF}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 704,
        PRESENT25: "No",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.98662497531038, 38.88020966142364],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Safeway",
        ADDRESS: "1100 4TH STREET SW",
        ZIPCODE: 20024,
        PHONE: 2025549155,
        WARD: "Ward 6",
        SSL: "0542    0872",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "Yes",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_64",
        XCOORD: 398511.05,
        YCOORD: 134420.39,
        MAR_ID: 307170,
        GLOBALID: "{A30D0370-6C3A-4079-9F2C-2EF7B5627C78}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 705,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.01716180534368, 38.87762150469111],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Harris Teeter",
        ADDRESS: "401 M St SE",
        ZIPCODE: 20003,
        PHONE: 2025540164,
        WARD: "Ward 8",
        SSL: "0771    0811",
        NOTES: "Navy Yard",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_65",
        XCOORD: 399991.82,
        YCOORD: 134265.15,
        MAR_ID: 309432,
        GLOBALID: "{1DB59107-6766-42A4-8BA2-5D6FC647D9EF}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 706,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.00009655130431, 38.87622430239727],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Safeway",
        ADDRESS: "2845 ALABAMA AVENUE SE",
        ZIPCODE: 20020,
        PHONE: 2025757525,
        WARD: "Ward 7",
        SSL: "5642    0001",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_66",
        XCOORD: 402892.75,
        YCOORD: 132357.23,
        MAR_ID: 278282,
        GLOBALID: "{A3BFCCAD-8C29-4BF5-91D7-A33915402BCF}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 707,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.96667322313844, 38.859032219035655],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Giant",
        ADDRESS: "1535 ALABAMA AVENUE SE",
        ZIPCODE: 20032,
        PHONE: 2026106464,
        WARD: "Ward 8",
        SSL: "5912    0818",
        NOTES: "Camp Simms",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_67",
        XCOORD: 401649.66,
        YCOORD: 130793.59,
        MAR_ID: 306557,
        GLOBALID: "{B9BAED96-5B48-4DD4-B08E-E531CF031451}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 708,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.98099933099755, 38.844949480177014],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Safeway",
        ADDRESS: "6500 PINEY BRANCH ROAD NW",
        ZIPCODE: 20012,
        PHONE: 2027235644,
        WARD: "Ward 4",
        SSL: "2974    0020",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_68",
        XCOORD: 397699.34,
        YCOORD: 144623.03,
        MAR_ID: 285341,
        GLOBALID: "{61779AAC-DFDE-4952-9C2E-9CF5BC9DEEF2}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 709,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02655061039643, 38.96952840268441],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Safeway",
        ADDRESS: "4203 DAVENPORT STREET NW",
        ZIPCODE: 20016,
        PHONE: 2023640290,
        WARD: "Ward 3",
        SSL: "1672    0815",
        NOTES: " ",
        PRESENT90: "Yes",
        PRESENT95: "Yes",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "No",
        PRESENT16: "No",
        PRESENT17: "No",
        PRESENT18: "No",
        PRESENT22: "No",
        PRESENT23: "No",
        PRESENT24: "No",
        GIS_ID: "GroceryStorePt_69",
        XCOORD: 392852.16,
        YCOORD: 142717.87,
        MAR_ID: 301160,
        GLOBALID: "{89BCAD9B-90E3-49D3-B89A-BE1A35447D76}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 710,
        PRESENT25: "No",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.08246449753962, 38.95234016155869],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Safeway",
        ADDRESS: "3830 GEORGIA AVENUE NW",
        ZIPCODE: 20011,
        PHONE: 2028821140,
        WARD: "Ward 4",
        SSL: "2905    0814",
        NOTES: " ",
        PRESENT90: "Yes",
        PRESENT95: "Yes",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_16",
        XCOORD: 397845.01,
        YCOORD: 141173.71,
        MAR_ID: 225076,
        GLOBALID: "{CE7A30D3-A0A7-4E3E-8C33-94EF828CF35D}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 711,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02485883166266, 38.93845637077936],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "BestWorld Supermarket",
        ADDRESS: "3178 MOUNT PLEASANT STREET NW",
        ZIPCODE: 20010,
        PHONE: 2022653768,
        WARD: "Ward 1",
        SSL: "2601    0667",
        NOTES: " ",
        PRESENT90: "Yes",
        PRESENT95: "Yes",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_22",
        XCOORD: 396658.16,
        YCOORD: 140340.12,
        MAR_ID: 233149,
        GLOBALID: "{38E91B45-9A3E-4AE6-BA7A-F6C9D2ED834B}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 712,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.03854438909197, 38.93094342714375],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Harris Teeter",
        ADDRESS: "1631 KALORAMA ROAD NW",
        ZIPCODE: 20009,
        PHONE: 2029861415,
        WARD: "Ward 1",
        SSL: "2572    0036",
        NOTES: "Citadel",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_28",
        XCOORD: 396666.63,
        YCOORD: 139345.87,
        MAR_ID: 284059,
        GLOBALID: "{9C7F3535-0563-49EB-94A7-AC647D52A781}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 713,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0384418623821, 38.921986941317144],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Giant",
        ADDRESS: "1050 BRENTWOOD ROAD NE",
        ZIPCODE: 20018,
        PHONE: 2022813900,
        WARD: "Ward 5",
        SSL: "3854    0802",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_34",
        XCOORD: 400656.59,
        YCOORD: 139039.13,
        MAR_ID: 299835,
        GLOBALID: "{8DCFB057-DC2B-4672-AF50-AEF4052A5E39}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 714,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.9924309344828, 38.91922980577211],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Dawson's Market",
        ADDRESS: "2001 S STREET NW",
        ZIPCODE: 20009,
        PHONE: 2025885698,
        WARD: "Ward 2",
        SSL: "0090    0032",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "No",
        PRESENT24: "No",
        GIS_ID: "GroceryStorePt_41",
        XCOORD: 396080.16,
        YCOORD: 138491.14,
        MAR_ID: 242564,
        GLOBALID: "{65033E44-B702-43E3-B52F-3FF94A0FB7E9}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 715,
        PRESENT25: "No",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.04520001770737, 38.914284831313104],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Capitol Super Market",
        ADDRESS: "1231 11TH STREET NW",
        ZIPCODE: 20001,
        PHONE: 2022891336,
        WARD: "Ward 2",
        SSL: "0340    0824",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_46",
        XCOORD: 397685.02,
        YCOORD: 137659.43,
        MAR_ID: 239341,
        GLOBALID: "{0613191B-5619-4A20-83D7-E7FEA9AF28FC}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 716,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02669235762392, 38.90679819583192],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Safeway",
        ADDRESS: "490 L STREET NW",
        ZIPCODE: 20001,
        PHONE: 2027192435,
        WARD: "Ward 6",
        SSL: "0515    0158",
        NOTES: "Mt. Vernon Square",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_52",
        XCOORD: 398408.1,
        YCOORD: 137292.77,
        MAR_ID: 304767,
        GLOBALID: "{009CF7A2-1951-4C57-8BB0-903A0D541736}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 717,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.01835490587573, 38.90349680089167],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Safeway",
        ADDRESS: "322 40TH STREET NE",
        ZIPCODE: 20019,
        PHONE: 2023972802,
        WARD: "Ward 7",
        SSL: "5051N   0840",
        NOTES: " ",
        PRESENT90: "Yes",
        PRESENT95: "Yes",
        PRESENT00: "Yes",
        PRESENT05: "Yes",
        PRESENT08: "Yes",
        PRESENT09: "Yes",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "Yes",
        PRESENT14: "Yes",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_77",
        XCOORD: 404558.4,
        YCOORD: 136144.21,
        MAR_ID: 295141,
        GLOBALID: "{DE137DF5-10A3-4008-852F-F1AD1DDB40AC}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 718,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.94745719705949, 38.89313978162217],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Yes! Organic",
        ADDRESS: "2323 PENNSYLVANIA AVENUE SE",
        ZIPCODE: 20020,
        PHONE: 2025821480,
        WARD: "Ward 7",
        SSL: "5560    0055",
        NOTES: " ",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "Yes",
        PRESENT11: "Yes",
        PRESENT12: "Yes",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "No",
        PRESENT16: "No",
        PRESENT17: "No",
        PRESENT18: "No",
        PRESENT22: "No",
        PRESENT23: "No",
        PRESENT24: "No",
        GIS_ID: "GroceryStorePt_78",
        XCOORD: 402365.01,
        YCOORD: 134033.39,
        MAR_ID: 48543,
        GLOBALID: "{C6D5AFFB-30F8-4FDA-9817-A07B591EB5E2}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 719,
        PRESENT25: "No",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97274786739939, 38.874133336463096],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Wegmans",
        ADDRESS: "41 RIDGE SQUARE NW",
        ZIPCODE: 20016,
        PHONE: 2024491600,
        WARD: "Ward 3",
        SSL: "1823    0804",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_80",
        XCOORD: 393327.16,
        YCOORD: 141364.5,
        MAR_ID: 331634,
        GLOBALID: "{35D83E77-B803-4AD4-9D93-07A2EF13217B}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 720,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0772664100344, 38.9404511450199],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Lidl",
        ADDRESS: "2224 TOWN CENTER DRIVE SE",
        ZIPCODE: 20020,
        PHONE: 8447475435,
        WARD: "Ward 7",
        SSL: "5633    0022",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_81",
        XCOORD: 402813.53,
        YCOORD: 132636.72,
        MAR_ID: 313156,
        GLOBALID: "{657A36ED-8179-4F52-B969-A9B5B5A37437}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 721,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.9674010833979, 38.86176558894161],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Good Food Markets",
        ADDRESS: "4001 SOUTH CAPITOL STREET SW",
        ZIPCODE: 20032,
        PHONE: 2022488496,
        WARD: "Ward 8",
        SSL: "6172    0815",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: "Yes",
        PRESENT23: "No",
        PRESENT24: "No",
        GIS_ID: "GroceryStorePt_82",
        XCOORD: 399303.3,
        YCOORD: 129237.48,
        MAR_ID: 276615,
        GLOBALID: "{6687A883-515F-4E5E-A252-2610DA85DDED}",
        CREATED: "2022-09-28T22:04:54Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 722,
        PRESENT25: "No",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.00808213858399, 38.83120451966465],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Streets Market",
        ADDRESS: "2617 P STREET NW",
        ZIPCODE: 20007,
        PHONE: 2027350996,
        WARD: "Ward 2",
        SSL: "1265    0101",
        NOTES: null,
        PRESENT90: null,
        PRESENT95: null,
        PRESENT00: null,
        PRESENT05: null,
        PRESENT08: null,
        PRESENT09: null,
        PRESENT10: null,
        PRESENT11: null,
        PRESENT12: null,
        PRESENT13: null,
        PRESENT14: null,
        PRESENT15: null,
        PRESENT16: null,
        PRESENT17: null,
        PRESENT18: null,
        PRESENT22: null,
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_83",
        XCOORD: 395200.42,
        YCOORD: 137964.35,
        MAR_ID: 275887,
        GLOBALID: "{07F7DAF6-0B56-43FE-9DC9-86634EF9DAFF}",
        CREATED: "2023-05-17T19:23:12Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 961,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0553401792372, 38.909534963873654],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Whole Foods Market",
        ADDRESS: "7130 12TH STREET NW",
        ZIPCODE: 20012,
        PHONE: 2028466680,
        WARD: "Ward 4",
        SSL: "2950    0003",
        NOTES: null,
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "No",
        PRESENT16: "No",
        PRESENT17: "No",
        PRESENT18: "No",
        PRESENT22: "No",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_84",
        XCOORD: 397559.56,
        YCOORD: 145352.71,
        MAR_ID: 334710,
        GLOBALID: "{D67B7C47-1873-455E-9891-CAA0F0D4DFBF}",
        CREATED: "2023-06-28T17:10:21Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 962,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0281662032648, 38.9761011542937],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Lidl",
        ADDRESS: "3100 14TH STREET NW, #116",
        ZIPCODE: 20010,
        PHONE: 8447475435,
        WARD: "Ward 1",
        SSL: "2674    0721",
        NOTES: null,
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "No",
        PRESENT16: "No",
        PRESENT17: "No",
        PRESENT18: "No",
        PRESENT22: "No",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_85",
        XCOORD: 397140.04,
        YCOORD: 140158.41,
        MAR_ID: 306304,
        GLOBALID: "{61B4CD00-7A62-4328-A071-834DEF99283A}",
        CREATED: "2023-06-28T17:18:47Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 963,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.03298601467985, 38.92930822797337],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "AmazonFresh",
        ADDRESS: "1733 14TH STREET NW",
        ZIPCODE: 20009,
        PHONE: null,
        WARD: "Ward 2",
        SSL: "0239    0131",
        NOTES: null,
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "No",
        PRESENT16: "No",
        PRESENT17: "No",
        PRESENT18: "No",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "No",
        GIS_ID: "GroceryStorePt_90",
        XCOORD: 397247.3,
        YCOORD: 138371.3,
        MAR_ID: 318767,
        GLOBALID: "{B7BC9F16-A487-45FA-B334-3F316A686E3D}",
        CREATED: "2024-09-30T19:43:40Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 1281,
        PRESENT25: "No",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.03174182533907, 38.91320970325571],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Union Kitchen Grocery",
        ADDRESS: "1251 9TH STREET NW",
        ZIPCODE: 20001,
        PHONE: 2027927850,
        WARD: "Ward 2",
        SSL: "0400    0852",
        NOTES: null,
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "No",
        PRESENT16: "No",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_87",
        XCOORD: 397942.66,
        YCOORD: 137691.32,
        MAR_ID: 301804,
        GLOBALID: "{4DAF45C3-D4AB-4483-9C6D-46E2ECE3B04A}",
        CREATED: "2024-09-30T21:11:17Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 1603,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02372205751968, 38.907086112987365],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Union Kitchen Grocery",
        ADDRESS: "1924 8TH STREET NW",
        ZIPCODE: 20005,
        PHONE: 2027927850,
        WARD: "Ward 1",
        SSL: "0393    2017",
        NOTES: null,
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "No",
        PRESENT16: "No",
        PRESENT17: "No",
        PRESENT18: "No",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "No",
        GIS_ID: "GroceryStorePt_89",
        XCOORD: 397986.86,
        YCOORD: 138741.56,
        MAR_ID: 310465,
        GLOBALID: "{F74916FB-B017-4045-9BA8-3623DA4F2C9D}",
        CREATED: "2024-09-30T21:11:17Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 1604,
        PRESENT25: "No",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02321554028883, 38.91654713512507],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Union Kitchen Grocery",
        ADDRESS: "1625 ECKINGTON PLACE NE",
        ZIPCODE: 20002,
        PHONE: 2027927850,
        WARD: "Ward 5",
        SSL: "3576    0057",
        NOTES: null,
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "No",
        PRESENT16: "No",
        PRESENT17: "No",
        PRESENT18: "No",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_86",
        XCOORD: 399653.12,
        YCOORD: 138237.1,
        MAR_ID: 145957,
        GLOBALID: "{60636EEE-00C8-44FA-A8DA-7A8896997FAD}",
        CREATED: "2024-09-30T21:11:17Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 1605,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0040018577073, 38.912005027447286],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Union Kitchen Grocery",
        ADDRESS: "1625 ECKINGTON PLACE NE",
        ZIPCODE: 20002,
        PHONE: 2027927850,
        WARD: "Ward 6",
        SSL: "0754    0098",
        NOTES: null,
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "Yes",
        PRESENT16: "Yes",
        PRESENT17: "Yes",
        PRESENT18: "Yes",
        PRESENT22: "Yes",
        PRESENT23: "Yes",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_88",
        XCOORD: 399808.33,
        YCOORD: 136593.94,
        MAR_ID: 9536,
        GLOBALID: "{F3D6C804-C6EA-4876-9246-F757ADC92793}",
        CREATED: "2024-09-30T21:11:17Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 1606,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0022118058978, 38.897202910067286],
      },
    },
    {
      type: "Feature",
      properties: {
        STORENAME: "Aldi",
        ADDRESS: "5300 SOUTH DAKOTA AVENUE NE",
        ZIPCODE: 20011,
        PHONE: 8003257894,
        WARD: "Ward 2",
        SSL: "3765 0011",
        NOTES: "Opened December 5, 2024",
        PRESENT90: "No",
        PRESENT95: "No",
        PRESENT00: "No",
        PRESENT05: "No",
        PRESENT08: "No",
        PRESENT09: "No",
        PRESENT10: "No",
        PRESENT11: "No",
        PRESENT12: "No",
        PRESENT13: "No",
        PRESENT14: "No",
        PRESENT15: "No",
        PRESENT16: "No",
        PRESENT17: "No",
        PRESENT18: "No",
        PRESENT22: "No",
        PRESENT23: "No",
        PRESENT24: "Yes",
        GIS_ID: "GroceryStorePt_90",
        XCOORD: 400023.97,
        YCOORD: 142958.37,
        MAR_ID: 320261,
        GLOBALID: "{BB6F0661-0A1D-4A8F-9020-F79D84E4AC0A}",
        CREATED: "2025-01-14T19:18:49Z",
        EDITED: "2025-01-14T19:33:19Z",
        SE_ANNO_CAD_DATA: null,
        OBJECTID: 1921,
        PRESENT25: "Yes",
      },
      geometry: {
        type: "Point",
        coordinates: [-76.9997257446131, 38.954535735345786],
      },
    },
  ],
};
